import React from "react";
import { PROJECT_MAX_BYTES, formatBytes } from "../lib/limits";

/** Project data (bytes) quota — used in Studio create / edit. */
export default function DataQuotaBar({
  usedBytes,
  pendingBytes = 0,
  loading = false,
}) {
  const total = usedBytes + pendingBytes;
  return (
    <QuotaBar
      label="Project data"
      used={total}
      max={PROJECT_MAX_BYTES}
      formatValue={formatBytes}
      ariaLabel="Project data quota"
      loading={loading}
      loadingLabel="Measuring…"
    />
  );
}

/** Generic quota bar (also used for Total Projects on Dashboard). */
export function QuotaBar({
  label,
  used,
  max,
  formatValue = (n) => String(n),
  ariaLabel,
  loading = false,
  loadingLabel = "Loading…",
}) {
  const safeMax = max > 0 ? max : 1;
  const pct = loading ? 0 : Math.min(100, Math.round((used / safeMax) * 100));
  const over = !loading && used > max;
  return (
    <div
      className={`data-quota ${over ? "data-quota--over" : ""} ${
        loading ? "data-quota--loading" : ""
      }`}
      aria-label={ariaLabel || label}
      aria-busy={loading || undefined}
    >
      <div className="data-quota__meta">
        <span>{label}</span>
        <span>
          {loading
            ? loadingLabel
            : `${formatValue(used)} / ${formatValue(max)}`}
        </span>
      </div>
      <div className="data-quota__track">
        <div className="data-quota__fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
